import makeSlice from '@web/slices/agreement/sliceMaker'

import {fetchSubscription} from '../../actions/subscription'

const slice = makeSlice({
    extraReducers(builder) {
        builder.addCase(fetchSubscription.fulfilled, (state) => {
            state.enabled = false
            state.selected = {
                booking: true,
                customOrder: true,
                familyPay: true,
                mallContract: true,
                personalDataCrossBorderTransfer: true,
                preOrder: true,
                thirdPeople: true,
                shoppingSubscription: false,
            }
            state.shoppingSubscription = true
        })
    },
})

export default slice.reducer
